import React from "react";
import { Arrow, Button } from "../../Styles/Global.Styled";
import { useNavigate } from "react-router-dom";
import { css } from "styled-components";

const bttnStyle = (top, left) => css`
  position: absolute;
  top: ${top || "1.5vh"};
  left: ${left || "5.5vw"};
  font-size: 1.5vh;
  z-index: 1;
`;
const leftSpace = css`
  left: 3vw;
`;
const arrowStyle = css`
  padding: 0.4vh;
  border-width: 0 0.35vh 0.35vh 0;
  border-color: grey;
`;

const NavBackButton = ({ top, left }) => {
  const navigate = useNavigate();
  return (
    <Button
      type="button"
      $baseStyle={bttnStyle(top, left)}
      $mStyle={leftSpace}
      onClick={() => navigate(-1)}
    >
      <Arrow $baseStyle={arrowStyle} $direction="left" />
      Back
    </Button>
  );
};

export default NavBackButton;
